import { classify } from 'sidecar-utilities'

// Used for the combobox's "Type to begin searching..." option.
// It's a non-clickable option.
export const basicOptionStyle = classify({
  group: 'group/item',
  layout: 'flex items-center gap-3',
  padding: 'px-4 py-3',
  bg: 'color-bgDefaultContainer',
})

export const optionStyle = classify({
  basicOptionStyle,
  cursor: 'cursor-pointer',
  hover: 'hover:color-bgDefaultContainer-hover hover:color-textPrimary-hover',
  active:
    'active:color-bgDefaultContainer-active active:color-textPrimary-active',
  activeItem:
    'data-[active-item]:color-bgDefaultContainer-hover data-[active-item]:color-textPrimary-hover',
  selected:
    'aria-selected:color-bgDefaultContainer-bold-default aria-selected:sh-strong',
})
